import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Биология. 6 класс.",
        subject: "Химический состав клетки",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Химический состав клетки",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Овчинников Алексей Васильевич",
                grade: "кандидат педагогических наук",
                subGrade: "",
                imageSrc: "./images/author1.jpg"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>В ходе изучения темы «Химический состав клетки» учащиеся знакомятся с особенностями органических и неорганических веществ, их ролью в жизни растения. Сложность в изучении веществ заключается в том, что до этого химический состав клетки не рассматривался курсе биологии, однако обучающиеся встречались с примерами различных веществ при изучении фотосинтеза, дыхания и некоторых других тем курса биологии. Таким образом актуальным является приведение в систему имеющихся первоначальных знаний и представлений учащихся о строении веществ, формирование знаний о различии в строении и химическом составе неорганических и органических соединений, свойствах и функциях разных видов веществ в организме растений. Особенность раскрытия данной темы заключается в том, что она не предполагает подробного знакомства с химическим строением веществ на уровне атомов и молекул. При изучении нового материала целесообразно переходить от рассмотрения конкретных примеров органических и неорганических веществ к общим свойствам данных соединений. Изучение веществ, для которых данный способ недоступен, осуществляется в обратной последовательности – от общих свойств к конкретным примерам. Именно такие подходы представлены в основном содержании кейса, в котором будут рассмотрены примеры лабораторных, практических работ и демонстраций по изучению органических и неорганических веществ и их свойств, показаны приемы обобщения и систематизации знаний и представлений обучающихся о строении и свойствах веществ, способы преобразования информации разных форм, различные способы достижения предметных, метапредметных и личностных результатов.</p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/biology.mp4"
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Пасечник В.В. Биология. 6 класс. Покрытосеменные растения: строение и жизнедеятельность. Учебник. Линейный курс. – Москва: Дрофа, 2021",
                "Пономарёва Н.И., Корнилова О. А., Кучменко В.С. Биология: Растения. Бактерии. Грибы. Лишайники: Учебник для учащихся 6 класса общеобразовательных учреждений. – Москва: Вентана-Граф, 2005",
                "Трайтак Д.И. Книга для чтения по ботанике. Пособие для учащихся. – Москва: Просвещение, 1978",
                "Федченкова Л.Н. Лабораторные работы для учащихся 6-x классов по личностно-ориентированной технологии // Биология, 2008",
                "Сухорукова Л.Н., Кучменко В.С. Биология. Живой организм. Тетрадь-практикум. 5-6 классы. Учеб. пособие для общеобразоват. организаций. – 7-е изд. – Москва: Просвещение, 2019",
                "Биология : 6-й класс : базовый уровень : учебник / В.В. Пасечник, С.В. Суматохин, З.Г. Гапонюк, Г.Г. Швецов; под ред. В.В. Пасечника. – Москва: Просвещение, 2022 – 160 с. "
            ],
            filesToDownload: [
                {
                    link: "./files/lab.pdf",
                    fileName: "Лабораторная работа «Определение физических свойств белков, жиров и углеводов»"
                }
            ]
        }
    ],
};
